import React from "react";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  barGraph: {
    display: "flex",
    flexDirection: "column",
    margin: "20px",
    width: "95%",
  },
  bar: {
    display: "flex",
    alignItems: "center",
    height: "30px",
    marginBottom: "5px",
  },
  barLabel: {
    padding: "5px",
    fontWeight: "bold",
  },
  barAmount: {
    marginLeft: "10px",
    color: "white",
  },
  barAmountNameContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
}));

const BarGraph = ({ data }) => {
  const classes = useStyles();

  const calculatePercentageWidth = (value, maxValue) => {
    return (value / maxValue) * 100 + "%";
  };

  const maxValue = Math.max(...data.map((item) => item[1]));

  return (
    <div className={classes.barGraph}>
      {data.map((item, index) => (
        <div>
          <div
            key={index}
            className={classes.bar}
            style={{
              width: calculatePercentageWidth(item[1], maxValue),
              backgroundColor: item[2].split(":")[1].trim(),
            }}
          ></div>
          <div className={classes.barAmountNameContainer}>
            <div className={classes.barLabel}>{item[0]}</div> - {item[1]}
          </div>
        </div>
      ))}
    </div>
  );
};

export default BarGraph;
